import React, { Component } from "react";
import JobTable from "../../../components/customer_portal/home/JobTable";
import { Box, Button } from "@mui/material";
import Store from "../../../containers/customer_portal/dashboard/HomePageStore";
import TablePaginationActions from "../../../components/customer_portal/home/TablePaginationActions";
import "@fontsource/lexend";
import withRouter from "../../../helpers/withRouter";
import SendProofModal from "../../../components/customer_portal/job/SendProofModal";
import AddIcon from '@mui/icons-material/Add';
import { isAuth } from "../../../helpers/cookies";
import { send_proof } from "../../../store/job/jobSlice";

class HomePageContainer extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    openSendProof: false,
    selectedJobId: null,
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const stageId = params.get('stage_id');
    const processId = params.get('process_id');

    if (stageId) {
      this.props.setStageTab(Number(stageId));
    }

    if (processId) {
      this.props.setProcessTab(Number(processId));
      this.props.setProcessHasJobForm(Number(processId));
    }

    if (stageId || processId) {
      window.history.replaceState({}, document.title, "/");
    }

    // Removed redundant company_process call; already handled in Layout
    // if (this.props.selected_company) {
    //   this.props.get_company_process(this.props.selected_company);
    // }

    // If navigating back to dashboard from the library, reset the selected stage
    const currentStage = this.props.selected_stage_tab;
    const isLibrary = currentStage === 'brand_library' || currentStage === 'my_library';

    if (isLibrary && this.props.company_process && this.props.company_process.length > 0) {
      const process = this.props.company_process.find(p => p.id === this.props.selected_process_tab) || this.props.company_process[0];
      if (process && process.stage && process.stage.length > 0) {
        this.props.setStageTab(process.stage[0].id);
      }
    }

    this.fetchJobs();
  }

  componentDidUpdate(prevProps) {
    const {
      selected_company,
      selected_process_tab,
      selected_stage_tab,
      searchFilters,
      company_process,
      fromDate,
      toDate,
      correctionType
    } = this.props;

    if (company_process && company_process.length > 0) {
      if (!selected_process_tab) {
        const firstProcess = company_process[0];
        this.props.setProcessTab(firstProcess.id);
        if (firstProcess.stage && firstProcess.stage.length > 0) {
          this.props.setStageTab(firstProcess.stage[0].id);
        }
        return;
      } else if (!selected_stage_tab || selected_stage_tab === 'brand_library' || selected_stage_tab === 'my_library') {
        const process = company_process.find(p => p.id === selected_process_tab);
        if (process && process.stage && process.stage.length > 0) {
          this.props.setStageTab(process.stage[0].id);
          return;
        }
      }
    }


    const paramsChanged = (
      prevProps.selected_company !== selected_company ||
      prevProps.selected_process_tab !== selected_process_tab ||
      prevProps.selected_stage_tab !== selected_stage_tab ||
      prevProps.searchFilters !== searchFilters ||
      prevProps.fromDate !== fromDate ||
      prevProps.toDate !== toDate ||
      prevProps.correctionType !== correctionType
    );

    if (paramsChanged && selected_process_tab && selected_stage_tab) {
      this.setState({ page: 0 }, () => this.fetchJobs());
    }
  }

  fetchJobs = () => {
    const {
      selected_company,
      selected_process_tab,
      selected_stage_tab,
      searchFilters,
      get_job_list,
    } = this.props;
    const { page, rowsPerPage } = this.state;

    // Prevent fetching if required parameters are missing
    if (!selected_company || !selected_process_tab || !selected_stage_tab) {
      return;
    }

    // Prevent fetching if stage is a library type
    if (String(selected_stage_tab) === 'brand_library' || String(selected_stage_tab) === 'my_library') {
      return;
    }

    const params = {
      company_id: selected_company,
      process_id: selected_process_tab,
      stage_id: selected_stage_tab,
      user_id: this.props.logged_in_user?.id,
      skip: page * rowsPerPage,
      limit: rowsPerPage,
    };

    if (searchFilters?.length > 0) {
      params.qn = searchFilters.map((f) => f.value.trim());
      const columns = searchFilters.map((f) => f.key).filter(Boolean);
      if (columns.length > 0) {
        params.column = columns;
      }
    }

    if (this.props.fromDate) {
      params.from_date = this.props.fromDate;
    }
    if (this.props.toDate) {
      params.to_date = this.props.toDate;
    }

    if (this.props.correctionType) {
      params.correction_type = this.props.correctionType;
    }

    get_job_list(params);
  };

  handlePageChange = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.fetchJobs();
    });
  };

  formatJobs = (jobs) => {
    const { search_columns } = this.props;

    if (!Array.isArray(jobs)) return [];

    return jobs.map((job) => {
      // 1. Handle submitted_file transformation
      let processedJob = { ...job };
      if (Array.isArray(job.submitted_file)) {
        processedJob = {
          ...processedJob,
          submitted_file: job.submitted_file.map((url) => {
            const filename = decodeURIComponent(url.split("/").pop());
            return { url, filename };
          }),
        };
      }

      // 2. Rename keys based on search_columns
      // Case A: Array of strings/objects (Recommended for ordering)
      if (Array.isArray(search_columns) && search_columns.length > 0) {
        const newJob = {};
        const jobKeys = Object.keys(processedJob);

        // 1. Add ordered keys from config
        search_columns.forEach(col => {
          // Since Backend already renames keys to the Label (display_name), 
          // we must use the LABEL to look up the value in the data, not the original key.
          const label = (typeof col === 'string') ? col : (col.label || col.key);

          if (processedJob.hasOwnProperty(label)) {
            newJob[label] = processedJob[label];
          }
        });

        // 2. Add remaining keys (excluding private keys for now)
        jobKeys.forEach(k => {
          const isConfigured = search_columns.some(col => {
            const cLabel = (typeof col === 'string') ? col : (col.label || col.key);
            return cLabel === k;
          });

          if (!isConfigured && k !== 'ref_No' && !k.startsWith('_')) {
            newJob[k] = processedJob[k];
          }
        });

        // 3. Preserve ALL helper keys starting with _
        jobKeys.forEach(k => {
          if (k.startsWith('_')) {
            newJob[k] = processedJob[k];
          }
        });

        return newJob;
      }

      // Case B: Legacy Object format (No guaranteed order in older environments, but modern JS preserves insertion order for string keys)
      if (search_columns && typeof search_columns === 'object') {
        const newJob = {};
        Object.keys(processedJob).forEach(key => {
          const label = search_columns[key];
          const newKey = label || key;
          newJob[newKey] = processedJob[key];
        });
        return newJob;
      }

      return processedJob;
    });
  };

  handleCreateJob = () => {
    const { selected_process_tab } = this.props;
    const url = selected_process_tab ? `/create-job?process_id=${selected_process_tab}` : "/create-job";
    this.props.navigate(url);
  };

  handleSendProof = async (jobId) => {
    try {
      const action = await this.props.get_job_detail({ job_id: jobId });
      if (!action.payload || !action.payload.data) {
        alert("Failed to fetch job details.");
        return;
      }

      const job_detail = action.payload.data;
      const jobData = job_detail.job_data || {};
      const compFileList = job_detail.comp_file_list || [];

      if (compFileList.length === 0) {
        alert("No completed files found to send.");
        return;
      }

      const sendToCustomer =
        jobData.send_art_to_customer === true ||
        jobData.send_art_to_customer === 'true' ||
        jobData.send_art_to_customer === 1;

      let recipientEmail = "";
      if (sendToCustomer) {
        recipientEmail = jobData.customer_email || jobData.customeremail;
        if (!recipientEmail) {
          alert("No customer email found in job data.");
          return;
        }
      } else {
        recipientEmail = job_detail.creator_email;
        if (!recipientEmail) {
          alert("No job creator (Rep) email found.");
          return;
        }
      }

      const payload = {
        ref_No: jobData.ref_No || "",
        customeremail: recipientEmail,
        job_id: parseInt(jobId),
        note: jobData.note || null,
        sent_to_cc: null,
        auth_user: parseInt(isAuth()?.user_id || isAuth()?.id),
        file_path: compFileList,
        is_customer: sendToCustomer,
      };

      if (isNaN(payload.auth_user)) {
        alert("Authentication Error: User ID not found.");
        return;
      }

      const resultAction = await this.props.send_proof(payload);
      if (send_proof.fulfilled.match(resultAction)) {
        this.fetchJobs();
      } else {
        const error = resultAction.payload || "Unknown error";
        alert(`Failed to send art: ${typeof error === 'object' ? JSON.stringify(error) : error}`);
      }
    } catch (error) {
      console.error("handleSendProof error:", error);
      alert("An unexpected error occurred while sending art.");
    }
  }

  setOpenSendProof = (val) => {
    this.setState({ openSendProof: val });
  }

  render() {
    const { job_list, job_total, common_loading, job_detail } = this.props;
    const { rowsPerPage } = this.state;
    const totalCount = job_total || 0;
    const formattedJobs = this.formatJobs(job_list);

    return (
      <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", mt: '-5px' }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
            mt: 0,
            px: 2,
            py: 1.5,
            gap: 2,
            backgroundColor: "#fff",
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            boxShadow: "none"
          }}
        >
          <Box
            sx={{
              fontSize: "20px",
              fontFamily: "'Inter Tight', sans-serif",
              color: "black",
              fontWeight: 600,
            }}
          >
            {(() => {
              const { company_process, selected_process_tab, selected_stage_tab } = this.props;
              let stageName = "";

              if (selected_process_tab && selected_stage_tab && company_process?.length > 0) {
                const process = company_process.find(p => p.id === selected_process_tab);
                if (process) {
                  const stage = process.stage?.find(s => s.id === selected_stage_tab);
                  if (stage) {
                    stageName = stage.name;
                  }
                }
              }

              if (selected_stage_tab === 'brand_library') stageName = "Brand Library";
              if (selected_stage_tab === 'my_library') stageName = "My Library";

              return stageName ? `Jobs : ${stageName}` : `Jobs - ${totalCount}`;
            })()}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>

            <TablePaginationActions
              count={totalCount}
              page={this.state.page}
              rowsPerPage={rowsPerPage}
              onPageChange={this.handlePageChange}
            />

            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={this.handleCreateJob}
              sx={{
                backgroundColor: "#ff6100",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#e55600",
                },
              }}
            >
              Create New Job
            </Button>

          </Box>
        </Box>

        <JobTable
          data={formattedJobs}
          total={totalCount}
          loading={common_loading}
          rowsPerPage={rowsPerPage}
          page={this.state.page}
          onPageChange={this.handlePageChange}
          selected_process_tab={this.props.selected_process_tab}
          selected_stage_tab={this.props.selected_stage_tab}
          company_process={this.props.company_process}
          onSendProof={this.handleSendProof}
          columns={this.props.table_columns}
        />


      </Box>
    );
  }
}

export default withRouter(Store(HomePageContainer));
